<div class="container mt-4">
    <form [formGroup]="form" autocomplete="off">
        <!-- hdfcpay -->
        <div class="card mb-4 shadow">
            <div [formGroup]="form.get('hdfcpay')">
                <div
                    class="card-header d-flex align-items-center justify-content-between"
                >
                    <div>
                        <input
                            type="checkbox"
                            class="form-check-input me-2 ml-1"
                            formControlName="selected"
                        />
                        <h5
                            class="mb-0 ml-4"
                            role="button"
                            (click)="
                                toggleForm(
                                    'toggleCcavenureForm',
                                    !toggleCcavenureForm
                                )
                            "
                        >
                            CCAvenue
                        </h5>
                    </div>
                    <div>
                        <!-- <label class="me-3 fw-bold mr-1">Environment:</label> -->
                        <div class="form-check form-check-inline ml-1">
                            <input
                                type="radio"
                                class="form-check-input"
                                id="cca-uat"
                                value="uat"
                                formControlName="env"
                            />
                            <label class="form-check-label" for="cca-uat">
                                <i class="fas fa-flask"></i> UAT
                            </label>
                        </div>
                        <div class="form-check form-check-inline ml-1">
                            <input
                                type="radio"
                                class="form-check-input"
                                id="cca-live"
                                value="live"
                                formControlName="env"
                            />
                            <label class="form-check-label" for="cca-live">
                                <i class="fas fa-play text-success"></i> Live
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card-body" *ngIf="toggleCcavenureForm">
                    <div class="row">
                        <div
                            class="col-md-6"
                            [formGroup]="form.get('hdfcpay').get('uat')"
                        >
                            <!-- uat input fields... -->
                            <h5 class="mt-3">UAT Parameters</h5>
                            <div class="mb-2">
                                <label>Merchant ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="merchant_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Access Code</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="access_code"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Key ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Status URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="status_url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="name"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Response URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="response_url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Redirect URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="redirect_url"
                                />
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mt-2 w-100"
                                (click)="saveEnv('hdfcpay', 'uat')"
                            >
                                <i class="fas fa-save"></i> Save UAT
                            </button>
                        </div>
                        <div
                            class="col-md-6"
                            [formGroup]="form.get('hdfcpay').get('live')"
                        >
                            <h5 class="mt-3">Live Parameters</h5>
                            <div class="mb-2">
                                <label>Merchant ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="merchant_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Access Code</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="access_code"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Key ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Status URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="status_url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="name"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Response URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="response_url"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Redirect URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="redirect_url"
                                />
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mt-2 w-100"
                                (click)="saveEnv('hdfcpay', 'live')"
                            >
                                <i class="fas fa-save"></i> Save Live
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- razorpay -->
        <div class="card mb-4 shadow">
            <div [formGroup]="form.get('razorpay')">
                <div
                    class="card-header d-flex align-items-center justify-content-between"
                >
                    <div>
                        <input
                            type="checkbox"
                            class="form-check-input me-2 ml-1"
                            formControlName="selected"
                        />
                        <h5
                            class="mb-0 ml-4"
                            role="button"
                            (click)="
                                toggleForm(
                                    'toggleRazorpayForm',
                                    !toggleRazorpayForm
                                )
                            "
                        >
                            Razorpay
                        </h5>
                    </div>
                    <div>
                        <!-- <label class="me-3 fw-bold mr-1">Environment:</label> -->
                        <div class="form-check form-check-inline ml-1">
                            <input
                                type="radio"
                                class="form-check-input"
                                id="razor-uat"
                                value="uat"
                                formControlName="env"
                            />
                            <label class="form-check-label" for="razor-uat">
                                <i class="fas fa-flask"></i> UAT
                            </label>
                        </div>
                        <div class="form-check form-check-inline ml-1">
                            <input
                                type="radio"
                                class="form-check-input"
                                id="razor-live"
                                value="live"
                                formControlName="env"
                            />
                            <label class="form-check-label" for="razor-live">
                                <i class="fas fa-play text-success"></i> Live
                            </label>
                        </div>
                    </div>
                </div>
                <div class="card-body" *ngIf="toggleRazorpayForm">
                    <div class="row">
                        <div
                            class="col-md-6"
                            [formGroup]="form.get('razorpay').get('uat')"
                        >
                            <!-- uat input fields... -->
                            <h5 class="mt-3">UAT Parameters</h5>
                            <div class="mb-2">
                                <label>Key ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Key Secret</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_secret"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Merchant Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="merchant_name"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Redirect URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="redirect_url"
                                />
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mt-2 w-100"
                                (click)="saveEnv('razorpay', 'uat')"
                            >
                                <i class="fas fa-save"></i> Save UAT
                            </button>
                        </div>
                        <div
                            class="col-md-6"
                            [formGroup]="form.get('razorpay').get('live')"
                        >
                            <!-- live input fields... -->
                            <h5 class="mt-3">Live Parameters</h5>
                            <div class="mb-2">
                                <label>Key ID</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_id"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Key Secret</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="key_secret"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Merchant Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="merchant_name"
                                />
                            </div>
                            <div class="mb-2">
                                <label>Redirect URL</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    formControlName="redirect_url"
                                />
                            </div>
                            <button
                                type="button"
                                class="btn btn-primary mt-2 w-100"
                                (click)="saveEnv('razorpay', 'live')"
                            >
                                <i class="fas fa-save"></i> Save Live
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
